import Controller from "./corporateInvoiceItem.controller";
import template from "./corporateInvoiceItem.html";

const corporateInvoiceItem = {
  template,
  controller: Controller,
};

export default corporateInvoiceItem;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoiceItem/corporateInvoiceItem.component.js